export default __webpack_public_path__ + "static/media/Twilio.33bd6711.svg";